/**
 * Fuente de verdad única para la configuración visual de tipos de widget.
 * Importar desde aquí en lugar de redefinir en cada componente.
 *
 * Usado por: WidgetManagerPanel, WidgetCustomizationPanel, Step3PresentationType.
 */

import {
  Hash, BarChart3, LayoutList, TrendingUp, PieChart, Table2, Image, Puzzle,
} from 'lucide-react';
import type { WidgetPresentationType } from '../types';

export interface WidgetTypeConfig {
  id: WidgetPresentationType;
  label: string;
  description: string;
  icon: React.FC<{ className?: string }>;
}

export const WIDGET_TYPE_CONFIG: WidgetTypeConfig[] = [
  {
    id: 'kpi',
    label: 'KPI',
    description: 'Un número principal con tendencia',
    icon: Hash,
  },
  {
    id: 'chart_bar_vertical',
    label: 'Barras',
    description: 'Comparación por categorías',
    icon: BarChart3,
  },
  {
    id: 'chart_bar_horizontal',
    label: 'Barras H.',
    description: 'Ranking horizontal',
    icon: LayoutList,
  },
  {
    id: 'chart_line',
    label: 'Líneas',
    description: 'Evolución temporal',
    icon: TrendingUp,
  },
  {
    id: 'chart_donut',
    label: 'Circular',
    description: 'Distribución porcentual',
    icon: PieChart,
  },
  {
    id: 'table',
    label: 'Tabla',
    description: 'Lista con columnas dinámicas',
    icon: Table2,
  },
  {
    id: 'image',
    label: 'Imagen',
    description: 'Imagen estática o dinámica',
    icon: Image,
  },
  {
    id: 'custom',
    label: 'Custom',
    description: 'Componente React personalizado',
    icon: Puzzle,
  },
];

/** Mapa tipo → config (para lookups O(1)) */
export const WIDGET_TYPE_MAP = Object.fromEntries(
  WIDGET_TYPE_CONFIG.map(c => [c.id, c])
) as Record<WidgetPresentationType, WidgetTypeConfig>;

/** Obtiene el ícono de un tipo. Fallback: Hash */
export function getTypeIcon(tipo: string): React.FC<{ className?: string }> {
  return WIDGET_TYPE_MAP[tipo as WidgetPresentationType]?.icon ?? Hash;
}

/** Obtiene el label de un tipo. Fallback: el tipo crudo */
export function getTypeLabel(tipo: string): string {
  return WIDGET_TYPE_MAP[tipo as WidgetPresentationType]?.label ?? tipo;
}
